import { atom } from "jotai";
import initialState from "./dictionaries/initialState";
import mediaValues from "./dictionaries/mediaValues";

import { atomWithReducer, atomWithStorage } from 'jotai/utils'

function atomWithCompare(initialValue, areEqual) {
  return atomWithReducer(initialValue, (prev, next) => {
    if (areEqual(prev, next)) {
      return prev
    }

    return next
  })
}

export const joinTeamAtom = atom(null)
export const disconnectAtom = atom(false)
export const backToMainMenuOpenAtom = atom(false)
export const gamePhaseAtom = atom(''); // lobby, pregame, game, winner, '' (room state not loaded yet)
export const readyToStartAtom = atom(false);
export const currentPlayerAtom = atom(false)
export const turnAtom = atom(JSON.parse(JSON.stringify(initialState.initialTurn)));
export const yootActiveAtom = atom(false);
export const spectatorsAtom = atom([])
export const clientAtom = atom({
  socketId: 'clientSocketId'
})
export const teamsAtom = atom(JSON.parse(JSON.stringify(initialState.initialTeams)))
export const messagesAtom = atom([]);
export const gameLogsAtom = atom([]);
export const roomAtom = atom({})
export const displayDisconnectAtom = atom(false)
export const hostAtom = atom({
  socketId: 'hostSocketId'
})
export const particleSettingAtom = atom(null)
export const yootThrowValuesAtom = atom(null)
export const yootThrownAtom = atom({
  flag: false,
  player: ''
})
export const displayScoreOptionsAtom = atom(false)
export const selectionAtom = atom(null)
export const tilesAtom = atom(JSON.parse(JSON.stringify(initialState.initialTiles)))
export const initialYootThrowAtom = atom(true)
export const lastMoveAtom = atom(null)
export const hasTurnAtom = atom(false)
export const turnAlertActiveAtom = atom(false)
export const yootAnimationAtom = atom(null)
export const yootOutcomeAtom = atom(null)
export const catchOutcomeAtom = atom({
  numPieces: 0,
  teamCaught: -1
})

export const pregameAlertAtom = atom({
  type: ''
})
export const throwAlertAtom = atom({
  type: '',
  num: -2,
  time: 0
})
export const moveResultAtom = atom({
  type: '',
  team: -1,
  amount: 0,
  tile: -1
})
export const throwResultAtom = atom({
  num: -2,
  time: 0
})
export const yootAnimationPlayingAtom = atom(false)
export const animationPlayingAtom = atom(false)
export const legalTilesAtom = atom({})
export const helperTilesAtom = atom({})
export const winnerAtom = atom(-1)
export const throwCountAtom = atom(0)
export const alertsAtom = atom([])
export const currentPlayerNameAtom = atom('')
export const catchPathAtom = atom(null)
export const bonusExistsAtom = atom(false)
export const showBonusAtom = atom(false)
export const shakeToThrowEnabledAtom = atom(false)
export const showShakeMeshAtom = atom(false)
export const addingDeviceMotionAtom = atom(false)
export const removingDeviceMotionAtom = atom(false)
// using an object to group the rules together has an issue
// editting a field doesn't trigger re-render of the toggle state
// when I click on the box to enable the rule, the box stays lit
// instead of highlighting in the hover state

// Rules
export const backdoLaunchAtom = atom(false)
export const timerAtom = atom(true)
export const nakAtom = atom(true)
export const yutMoCatchAtom = atom(false)
export const shortcutOptionsAtom = atom(false)
export const minigameRuleAtom = atom(false)

export const connectedToServerAtom = atom(true)
export const isOnlineAtom = atom(true)
export const pauseGameAtom = atom(false)
export const languageAtom = atomWithStorage('language', 'english')
export const timeLeftAtom = atom(60); // seconds
export const timerOnAtom = atom(false);
export const turnStartTimeAtom = atom(null);
export const turnExpireTimeAtom = atom(null);
export const remainingTimeAtom = atom(100000);
export const resultsAtom = atom([])
export const fireworkTexturesAtom = atom([])
export const meteorTexturesAtom = atom([])
export const moonTextureAtom = atom(null)
export const pieceTeam0Id0AnimationPlayingAtom = atom(false)
export const pieceTeam0Id1AnimationPlayingAtom = atom(false)
export const pieceTeam0Id2AnimationPlayingAtom = atom(false)
export const pieceTeam0Id3AnimationPlayingAtom = atom(false)
export const pieceTeam1Id0AnimationPlayingAtom = atom(false)
export const pieceTeam1Id1AnimationPlayingAtom = atom(false)
export const pieceTeam1Id2AnimationPlayingAtom = atom(false)
export const pieceTeam1Id3AnimationPlayingAtom = atom(false)
export const joinGameModalDisplayAtom = atom(false)
export const showFinishMovesAtom = atom(false)
export const logDisplayAtom = atom('chat')
export const showGameRulebookAtom = atom(false)

// Settings
export const settingsOpenAtom = atom(false)
export const mainMenuOpenAtom = atom(true)
export const editGuestsOpenAtom = atom(false)
export const guestBeingEdittedAtom = atom(null)
export const editOneGuestOpenAtom = atom(false)
export const resetGameOpenAtom = atom(false)
export const setGameRulesOpenAtom = atom(false)
export const viewGuestsOpenAtom = atom(false)
export const viewGameRulesOpenAtom = atom(false)
export const languageOpenAtom = atom(false)
export const lastYutAtom = atom(null)
export const seatChosenAtom = atom(null) // [team, seatIndex]
export const hasAIAtom = atom(false)

// display
// lobby
export const portraitLobbySelectionAtom = atom('players')
export const landscapeLobbyThirdSectionSelectionAtom = atom('invite')

// sounds
export const listenerAtom = atom(null)
export const audioLoaderAtom = atom(null)
export const musicListenerAtom = atom(null)
export const musicLoaderAtom = atom(null)
export const musicAtom = atom(null)
export const soundEffectAtom = atom(null)
export const blueMoonBrightnessAtom = atom(null)
export const audioContextAtom = atom(null)
export const audioVolumeAtom = atom(0) // 1 when you create room.

// mini game
export const minigameGamePhaseAtom = atom('start')
export const minigameCountdownAtom = atom(null)
export const minigameScoresAtom = atom({ 0: 0, 1: 0 })
export const minigameTimeRemainingAtom = atom(40)
export const minigameMessageAtom = atom('')
export const minigameStarsAtom = atom(JSON.parse(JSON.stringify(initialState.initialMinigameStars)))
export const minigameOpponentShakeAtom = atom({ team: null, expiresAt: null, type: null })
export const minigameStarPopAtom = atom(null)
export const minigameStateAtom = atom({})
export const minigameDodgeFrameAtom = atom({ players: {} })
export const minigameHideAndSeekCatchAtom = atom(null)
export const minigameHideAndSeekShotAtom = atom(null)

const deepPieceEquals = (prev, next) => {
  let result;
  if (prev.tile === next.tile) {
    result = true
  } else {
    result = false
  }
  return result;
}

export const pieceTeam0Id0Atom = atomWithCompare(
  JSON.parse(JSON.stringify(initialState.initialTeams[0].pieces[0])),
  deepPieceEquals
)
export const pieceTeam0Id1Atom = atomWithCompare(
  JSON.parse(JSON.stringify(initialState.initialTeams[0].pieces[1])),
  deepPieceEquals
)
export const pieceTeam0Id2Atom = atomWithCompare(
  JSON.parse(JSON.stringify(initialState.initialTeams[0].pieces[2])),
  deepPieceEquals
)
export const pieceTeam0Id3Atom = atomWithCompare(
  JSON.parse(JSON.stringify(initialState.initialTeams[0].pieces[3])),
  deepPieceEquals
)
export const pieceTeam1Id0Atom = atomWithCompare(
  JSON.parse(JSON.stringify(initialState.initialTeams[1].pieces[0])),
  deepPieceEquals
)
export const pieceTeam1Id1Atom = atomWithCompare(
  JSON.parse(JSON.stringify(initialState.initialTeams[1].pieces[1])),
  deepPieceEquals
)
export const pieceTeam1Id2Atom = atomWithCompare(
  JSON.parse(JSON.stringify(initialState.initialTeams[1].pieces[2])),
  deepPieceEquals
)
export const pieceTeam1Id3Atom = atomWithCompare(
  JSON.parse(JSON.stringify(initialState.initialTeams[1].pieces[3])),
  deepPieceEquals
)

// Set device
function initializeDevice(windowWidth, landscapeCutoff) {
  if (windowWidth < landscapeCutoff) {
    return "portrait"
  } else {
    return "landscapeDesktop"
  }
}

// window.innerWidth captured even though this component doesn't render anything visible
export const deviceAtom = atom(initializeDevice(window.innerWidth, mediaValues.landscapeCutoff))
export const languageModalOpenAtom = atom(false)